"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTokenStandard = exports.TokenStandard = void 0;
const pda_1 = require("./pda");
const mpl = __importStar(require("@metaplex-foundation/mpl-token-metadata"));
var TokenStandard;
(function (TokenStandard) {
    TokenStandard[TokenStandard["ProgrammableNft"] = 0] = "ProgrammableNft";
    TokenStandard[TokenStandard["Spl"] = 1] = "Spl";
})(TokenStandard = exports.TokenStandard || (exports.TokenStandard = {}));
async function getTokenStandard(connection, mint) {
    try {
        const metadataAddr = await pda_1.getMetadata(mint);
        const metadata = await mpl.Metadata.fromAccountAddress(connection, metadataAddr, "confirmed");
        if (metadata.tokenStandard === mpl.TokenStandard.ProgrammableNonFungible) {
            return TokenStandard.ProgrammableNft;
        }
    }
    catch (_e) {
        // silently ignore
    }
    return TokenStandard.Spl;
}
exports.getTokenStandard = getTokenStandard;
